import axios from 'axios';
import { getApiBaseUrl, logDomainConfig } from '../utils/domainUtils';

const API_URL = getApiBaseUrl();

// Log domain configuration for debugging
logDomainConfig();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('401 error, clearing auth data'); // Debug log
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Don't redirect here, let the component handle it
    }
    return Promise.reject(error);
  }
);

// Export domain utilities for other components
export { getDomainConfig, getCurrentDomain } from '../utils/domainUtils';

export default api;

